import * as z from 'zod';
import { BASE_URL } from '@/common/constants';

interface GetDataParams<DataType> {
  path: string;
  queryParams?: Record<string, string>;
  eventId: string;
  language: string;
  schema: z.ZodType<DataType>;
}

/** Fetches and validates data from the API. */
export default async function getData<DataType>(params: GetDataParams<DataType>) {
  const { path, queryParams = {}, eventId, language, schema } = params;

  if (eventId === '') {
    return null;
  }

  const encodedEventId = encodeURIComponent(eventId);
  const url = new URL(`/api/prematch/${path}/${encodedEventId}`, BASE_URL);
  url.searchParams.append('locale', language);

  for (const [key, value] of Object.entries(queryParams)) {
    url.searchParams.append(key, value);
  }

  const response = await fetch(url.toString());

  if (!response.ok) {
    throw new Error(
      `Failed to fetch ${path} for event ${eventId}: ${response.status} ${response.statusText}`,
    );
  }

  const data = await response.json();

  const result = schema.safeParse(data);

  if (!result.success) {
    throw new Error(`Invalid response for ${path} (event ${eventId}): ${result.error.message}`);
  }

  return result.data;
}
